/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Updates_DetailInputs */

const en_marketing_faq_updates_detail = /** @type {(inputs: Marketing_Faq_Updates_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx is the foundation JXD builds client products on, so it improves continuously. The changelog tracks every drop, and because you own the fork, you pull what you want when you want it.`)
};

const es_marketing_faq_updates_detail = /** @type {(inputs: Marketing_Faq_Updates_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx es la base sobre la que JXD construye los productos de sus clientes, así que mejora continuamente. El registro de cambios recoge cada entrega y, como el fork es tuyo, incorporas lo que quieras cuando quieras.`)
};

const fr_marketing_faq_updates_detail = /** @type {(inputs: Marketing_Faq_Updates_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx est la fondation sur laquelle JXD construit les produits de ses clients : elle s'améliore en continu. Le journal des modifications suit chaque livraison et, comme le fork vous appartient, vous récupérez ce que vous voulez quand vous le voulez.`)
};

/**
* | output |
* | --- |
* | "Onyx is the foundation JXD builds client products on, so it improves continuously. The changelog tracks every drop, and because you own the fork, you pull wh..." |
*
* @param {Marketing_Faq_Updates_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_updates_detail = /** @type {((inputs?: Marketing_Faq_Updates_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Updates_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_updates_detail(inputs)
	if (locale === "es") return es_marketing_faq_updates_detail(inputs)
	return fr_marketing_faq_updates_detail(inputs)
});